// ── AUTO-GENERATED by scripts/parse-content.js ────────────
// Do not edit this file directly.
// Edit files in content/ and run: npm run parse-content

// ── Types ──────────────────────────────────────────────────
export interface Project {
  num: string;
  title: string;
  italic: string;
  desc: string;
  tags: string[];
  link?: string;
}

export interface Company {
  name: string;
  location: string;
  badge?: string;
  current?: boolean;
  clients?: string[];
}

export interface Stat {
  number: string;
  label: string;
}

export interface SocialLink {
  id: string;
  label: string;
  handle: string;
  href: string;
}

export interface BlogChapter {
  kind: 'title' | 'body' | 'quote' | 'end';
  eyebrow?: string;
  title?: string;
  sub?: string;
  head?: string;
  body?: string;
  q?: string;
  by?: string;
  cta?: string;
  href?: string;
}

export interface Blog {
  id: string;
  date: string;
  year: string;
  cat: string;
  read: string;
  title: string;
  excerpt: string;
  cover: { c1: string; c2: string; glyph: string };
  chapters: BlogChapter[];
}

export interface NowItem {
  title: string;
  desc: string;
  live?: boolean;
}

export interface HeroData {
  eyebrow: string;
  title_line1: string;
  title_em: string;
  title_line3: string;
  lede: string;
  location: string;
  ring: boolean;
}

export interface AboutData {
  quote: string;
  body: string;
  meta: Array<{ label: string; value: string }>;
}

export interface OutroData {
  heading_line1: string;
  heading_em: string;
  sub: string;
  cta_label: string;
  cta_href: string;
  replay_label: string;
}

export interface ContactRow {
  label: string;
  value: string;
  href: string;
}

export interface WritingPost {
  title: string;
  date: string;
  cat: string;
  read: string;
}

// ── Data ───────────────────────────────────────────────────

export const HERO: HeroData = {
    eyebrow: 'Backend & AI Engineer · v7.0',
    title_line1: 'Shipping',
    title_em: 'production',
    title_line3: 'since 2018.',
    lede: '7 years in production. $900K+ saved on Plaid. $1M+/month GMV shipped. Currently deployed at Gerald (YC W21) — Sylhet, BD, available globally.',
    location: 'LIVE · SYLHET · UTC+6',
    ring: true,
  };

export const NOW_ITEMS: NowItem[] = [
    {
      title: 'AI Analytics Agents',
      desc: 'Slack agents that query Redshift in plain English. No SQL needed, no waiting on data teams.',
      live: true,
    },
    {
      title: 'SEO Content Engine',
      desc: '2,500 posts/hour. Automated keyword targeting, backlinking, scheduling. Agency eliminated.',
    },
    {
      title: 'Observability Stack',
      desc: 'New Relic + Datadog. Dashboards that don\'t lie about the status code. Alerts before users notice.',
    },
  ];

export const STATS: Stat[] = [
    {
      number: '$900K',
      label: 'Plaid costs, vaporized yearly',
    },
    {
      number: '$1M+',
      label: 'Monthly GMV, no inventory risk',
    },
    {
      number: '2,500+',
      label: 'SEO posts/hr, agency replaced',
    },
    {
      number: '80%',
      label: 'Support time, automated away',
    },
  ];

export const PROJECTS: Project[] = [
    {
      num: '001',
      title: 'Plaid',
      italic: 'Optimizer',
      desc: 'The bank connection funnel was bleeding $100K/month. I re-engineered it to defer API calls until users committed. 75% cost reduction, same completion rate. $900K saved annually.',
      tags: ['Python', 'FastAPI', 'Analytics'],
    },
    {
      num: '002',
      title: 'AI',
      italic: 'SEO Engine',
      desc: 'Agency was charging $8K/month for generic content. Built an AI pipeline that generates 2,500 posts/hour with automated keyword targeting. $96K/yr saved, 40% conversion lift, $1M+ monthly GMV.',
      tags: ['AI/ML', 'Automation', 'SEO'],
    },
    {
      num: '003',
      title: 'Amazon',
      italic: 'Integration',
      desc: 'Gerald\'s catalog was limited. Integrated Zinc API to sell Amazon products directly — zero inventory risk, Amazon handles fulfillment. $1M+ monthly order value within months.',
      tags: ['Zinc API', 'Integration', 'E-commerce'],
    },
  ];

export const COMPANIES: Company[] = [
    {
      name: 'Gerald',
      location: 'USA · Remote',
      badge: 'YC W21',
      current: true,
    },
    {
      name: 're:cruit',
      location: 'USA · Contract',
      clients: ['Replo', 'First Delivery', 'Edlyft', 'Osmind'],
    },
    {
      name: 'SJ Innovation',
      location: 'Bangladesh',
    },
    {
      name: 'Social Energy',
      location: 'UK · Remote',
    },
  ];

export const SKILLS_PRIMARY = ['Python', 'FastAPI', 'LangChain', 'LangGraph', 'React', 'Next.js', 'Node.js'];
export const SKILLS_SECONDARY = ['AWS', 'GCP', 'Docker', 'Redshift', 'pgvector', 'MongoDB', 'New Relic', 'Datadog', 'Zinc API'];

export const SOCIALS: SocialLink[] = [
    {
      id: 'github',
      label: 'GitHub',
      handle: '@AnisurRahmann',
      href: 'https://github.com/anisurrahmann',
    },
    {
      id: 'linkedin',
      label: 'LinkedIn',
      handle: '/in/shakil22',
      href: 'https://linkedin.com/in/shakil22',
    },
    {
      id: 'x',
      label: 'X',
      handle: '@ar_shakil23',
      href: 'https://x.com/ar_shakil23',
    },
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      handle: '+44 7763807656',
      href: 'https://wa.me/447763807656',
    },
    {
      id: 'email',
      label: 'Email',
      handle: 'pshakilwizard@gmail.com',
      href: 'mailto:pshakilwizard@gmail.com',
    },
  ];

export const CONTACT_ROWS: ContactRow[] = [
    {
      label: 'Email',
      value: 'pshakilwizard@gmail.com',
      href: 'mailto:pshakilwizard@gmail.com',
    },
    {
      label: 'GitHub',
      value: '@AnisurRahmann',
      href: 'https://github.com/anisurrahmann',
    },
    {
      label: 'LinkedIn',
      value: '/in/shakil22',
      href: 'https://linkedin.com/in/shakil22',
    },
    {
      label: 'X',
      value: '@ar_shakil23',
      href: 'https://x.com/ar_shakil23',
    },
    {
      label: 'WhatsApp',
      value: '+44 7763807656',
      href: 'https://wa.me/447763807656',
    },
    {
      label: 'Calendar',
      value: 'cal.com/shakil-nee',
      href: 'https://cal.com/shakil-nee/30min',
    },
  ];

export const ABOUT: AboutData = {
    quote: 'I don\'t brainstorm. I ship. Pipelines that cut $900K/year, AI engines that replace agencies, integrations that unlock $1M+ GMV.',
    body: 'Started in 2018 building energy monitoring for the UK grid. Spent 2.5+ years at Gerald (YC W21) converting engineering problems into revenue — $900K saved on Plaid costs, $96K/yr by replacing an SEO agency with AI, $1M+ monthly GMV through Amazon integration. Every feature I ship has a number attached to it. B.E. Computer Science, 2021.',
    meta: [
      {
        label: 'Deployed at',
        value: 'Sylhet, BD · UTC+6',
      },
      {
        label: 'Uptime',
        value: '7 years, 0 unplanned outages',
      },
      {
        label: 'Stack',
        value: 'Python · Go · React · AWS',
      },
      {
        label: 'Status',
        value: 'Open to Senior/Staff roles',
      },
    ],
  };

export const OUTRO: OutroData = {
    heading_line1: 'Don\'t redeploy',
    heading_em: 'this engineer.',
    sub: 'Already running in production. Open to new environments — email, coffee chat, or technical interview all welcome.',
    cta_label: 'Email me →',
    cta_href: 'mailto:pshakilwizard@gmail.com',
    replay_label: 'Replay',
  };

export const WRITING_POSTS: WritingPost[] = [
    {
      title: 'How I cut $900K/year from Plaid costs',
      date: 'Apr 18 2026',
      cat: 'Cost Engineering',
      read: '5 min',
    },
    {
      title: 'Building an AI SEO engine at scale',
      date: 'Apr 11 2026',
      cat: 'AI Automation',
      read: '6 min',
    },
    {
      title: 'From zero to $1M monthly GMV with Amazon integration',
      date: 'Apr 04 2026',
      cat: 'Revenue',
      read: '4 min',
    },
    {
      title: 'Cutting support time 80% with smart automation',
      date: 'Mar 28 2026',
      cat: 'Operations',
      read: '5 min',
    },
    {
      title: 'Observability that cut MTTR by 60%',
      date: 'Mar 15 2026',
      cat: 'Reliability',
      read: '6 min',
    },
    {
      title: 'Building from Sylhet',
      date: 'Mar 02 2026',
      cat: 'Personal',
      read: '4 min',
    },
    {
      title: 'Engineering as a profit center',
      date: 'Feb 19 2026',
      cat: 'Philosophy',
      read: '5 min',
    },
  ];

export const BLOGS: Blog[] = [
  {
    id: 'plaid-costs',
    date: 'Apr 18',
    year: '2026',
    cat: 'Cost Engineering',
    read: '5 min',
    title: 'How I cut $900K/year from Plaid costs',
    excerpt: 'The bank connection funnel was bleeding $100K/month. Here is how I engineered it down to $25K without breaking UX.',
    cover: { c1: '#22c55e', c2: '#0a5e3e', glyph: '\u25C8' },
    chapters: [
  {
    kind: 'title',
    eyebrow: 'Ch. 01',
    title: '$900K back on the table',
    sub: 'Nobody noticed the cost until I mapped every API call in the funnel.',
  },
  {
    kind: 'body',
    head: 'The bleeding',
    body: 'Plaid charges per connection attempt. We were triggering connections at every step — even when the user wasn\'t ready to complete. $100K/month with no ceiling in sight.',
  },
  {
    kind: 'body',
    head: 'The fix',
    body: 'I re-engineered the connection funnel to defer API calls until the user committed to linking. Added validation steps before the Plaid call. Result: 75% cost reduction, same completion rate.',
  },
  {
    kind: 'quote',
    q: 'Cost optimization isn\'t about cutting features. It\'s about cutting waste.',
  },
  {
    kind: 'body',
    head: 'What I learned',
    body: 'Map the funnel first. Every API call has a cost. Most of them are unnecessary if you think about the user flow carefully.',
  },
  {
    kind: 'end',
    cta: 'Get in touch →',
    href: 'mailto:pshakilwizard@gmail.com',
  }
    ],
  },
  {
    id: 'ai-seo',
    date: 'Apr 11',
    year: '2026',
    cat: 'AI Automation',
    read: '6 min',
    title: 'Building an AI SEO engine at scale',
    excerpt: 'We were paying $8K/month to an agency. I built a system that generates 2,500 posts/hour and drives $1M+ monthly GMV.',
    cover: { c1: '#3b82f6', c2: '#1e3a8a', glyph: '\u2B22' },
    chapters: [
  {
    kind: 'title',
    eyebrow: 'Ch. 02',
    title: 'Replace the agency',
    sub: '$96K/year saved. 40% more organic conversions. One AI pipeline.',
  },
  {
    kind: 'body',
    head: 'The problem',
    body: 'Third-party SEO agency was expensive, slow, and producing generic content. $8K/month for blog posts that weren\'t moving any numbers.',
  },
  {
    kind: 'body',
    head: 'What I built',
    body: 'An AI-powered content engine that generates 2,500 SEO-optimized blog posts per hour. Automated keyword targeting, backlink strategy, and content scheduling. Zero human intervention needed after setup.',
  },
  {
    kind: 'body',
    head: 'The impact',
    body: 'Eliminated the agency cost entirely. Organic traffic conversions up 40%. Direct contributor to $1M+ monthly GMV through increased discovery.',
  },
  {
    kind: 'quote',
    q: 'If you\'re paying an agency for something a well-engineered pipeline can do better, you\'re doing it wrong.',
  },
  {
    kind: 'end',
    cta: 'Get in touch →',
    href: 'mailto:pshakilwizard@gmail.com',
  }
    ],
  },
  {
    id: 'amazon-gmv',
    date: 'Apr 04',
    year: '2026',
    cat: 'Revenue',
    read: '4 min',
    title: 'From zero to $1M monthly GMV with Amazon integration',
    excerpt: 'How integrating Zinc API unlocked a new revenue stream with zero inventory risk.',
    cover: { c1: '#f97316', c2: '#7c2d12', glyph: '\u25B2' },
    chapters: [
  {
    kind: 'title',
    eyebrow: 'Ch. 03',
    title: '$1M monthly, zero inventory',
    sub: 'Sometimes the best product play is not building the product yourself.',
  },
  {
    kind: 'body',
    head: 'The opportunity',
    body: 'Gerald\'s catalog was limited. Users wanted more products. Building our own supply chain would take months and burn cash we didn\'t have.',
  },
  {
    kind: 'body',
    head: 'The integration',
    body: 'I integrated Zinc API to enable Amazon product sales directly on Gerald\'s platform. Amazon handles fulfillment. We handle the user experience. No inventory risk.',
  },
  {
    kind: 'body',
    head: 'The numbers',
    body: 'Within months, the Amazon integration was driving $1M+ in monthly order value. New revenue stream, improved unit economics through FBA.',
  },
  {
    kind: 'quote',
    q: 'The best integrations are the ones where both sides win and the user never sees the seams.',
  },
  {
    kind: 'end',
    cta: 'Get in touch →',
    href: 'mailto:pshakilwizard@gmail.com',
  }
    ],
  },
  {
    id: 'support-auto',
    date: 'Mar 28',
    year: '2026',
    cat: 'Operations',
    read: '5 min',
    title: 'Cutting support time 80% with smart automation',
    excerpt: 'Engineering was bottlenecked on routine customer issues. I built a system that let CS resolve them independently.',
    cover: { c1: '#a855f7', c2: '#4c1d95', glyph: '\u2726' },
    chapters: [
  {
    kind: 'title',
    eyebrow: 'Ch. 04',
    title: 'Free the engineers',
    sub: 'Customer support shouldn\'t need an engineer on standby for every ticket.',
  },
  {
    kind: 'body',
    head: 'The bottleneck',
    body: 'Every routine customer issue needed engineering intervention. CS teams couldn\'t resolve basic problems without filing a ticket and waiting. Response times were slow. Engineers were distracted.',
  },
  {
    kind: 'body',
    head: 'The system',
    body: 'I built a smart action system that gave CS teams the tools to resolve issues on their own. Policy lookups, account actions, and resolution workflows — all self-service.',
  },
  {
    kind: 'body',
    head: 'The result',
    body: '80% reduction in engineering time spent on support. Faster resolution times for customers. CS team empowered instead of dependent.',
  },
  {
    kind: 'quote',
    q: 'Build tools that scale your team, not your headcount.',
  },
  {
    kind: 'end',
    cta: 'Get in touch →',
    href: 'mailto:pshakilwizard@gmail.com',
  }
    ],
  },
  {
    id: 'observability',
    date: 'Mar 15',
    year: '2026',
    cat: 'Reliability',
    read: '6 min',
    title: 'Observability that cut MTTR by 60%',
    excerpt: 'When something breaks at 2am, you want to know before your users do. Here is the stack I built.',
    cover: { c1: '#eab308', c2: '#713f12', glyph: '\u25CF' },
    chapters: [
  {
    kind: 'title',
    eyebrow: 'Ch. 05',
    title: 'Fix it before they notice',
    sub: 'Proactive monitoring, AI-powered alerts, and a 60% faster recovery time.',
  },
  {
    kind: 'body',
    head: 'The stack',
    body: 'Comprehensive monitoring with New Relic and Datadog across all services. Custom dashboards for engineering and ops teams. Smart alerts that catch problems before they cascade.',
  },
  {
    kind: 'body',
    head: 'The AI layer',
    body: 'Deployed AI Slack agents that give instant access to business metrics and let anyone query Redshift using natural language. No SQL knowledge needed.',
  },
  {
    kind: 'body',
    head: 'The impact',
    body: '60% reduction in Mean Time To Recovery. Democratized data access across teams. Proactive downtime prevention instead of reactive firefighting.',
  },
  {
    kind: 'quote',
    q: 'The best monitoring is the kind that wakes you up before the customer notices, not after.',
  },
  {
    kind: 'end',
    cta: 'Get in touch →',
    href: 'mailto:pshakilwizard@gmail.com',
  }
    ],
  },
  {
    id: 'sylhet',
    date: 'Mar 02',
    year: '2026',
    cat: 'Personal',
    read: '4 min',
    title: 'Building from Sylhet',
    excerpt: 'Remote-first for 7 years. The tradeoffs nobody writes about.',
    cover: { c1: '#06b6d4', c2: '#164e63', glyph: '\u25C9' },
    chapters: [
  {
    kind: 'title',
    eyebrow: 'Ch. 06',
    title: 'Remote from Sylhet',
    sub: 'UTC+6. Seven years. Every day a tradeoff.',
  },
  {
    kind: 'body',
    head: 'What works',
    body: 'Deep work blocks that nobody in SF or London can interrupt. Thinking time before the West wakes up. A cost of living that lets me pick projects for impact, not rent. 2.5+ years at Gerald proved remote engineers can drive $900K savings and $1M+ GMV from anywhere.',
  },
  {
    kind: 'body',
    head: 'What doesn\'t',
    body: 'Spontaneous whiteboard sessions. Watercooler alpha. Being in the room when the big decision gets made. You compensate with over-communication and extreme ownership.',
  },
  {
    kind: 'quote',
    q: 'Remote work rewards the disciplined and punishes everyone else. I take full ownership from code to production to monitoring — no hand-holding needed.',
  },
  {
    kind: 'end',
    cta: 'Reach out →',
    href: 'mailto:pshakilwizard@gmail.com',
  }
    ],
  },
  {
    id: 'impact',
    date: 'Feb 19',
    year: '2026',
    cat: 'Philosophy',
    read: '5 min',
    title: 'Engineering as a profit center',
    excerpt: 'Every line of code should have ROI. Here is my framework for impact-driven engineering.',
    cover: { c1: '#ef4444', c2: '#7f1d1d', glyph: '\u2715' },
    chapters: [
  {
    kind: 'title',
    eyebrow: 'Ch. 07',
    title: 'Ship results, not features',
    sub: 'If it didn\'t move a number, it didn\'t matter.',
  },
  {
    kind: 'body',
    head: 'Day 1 impact',
    body: 'I don\'t need 3 months to ramp up. At Gerald I found high-impact problems fast: $900K saved on Plaid costs, $96K saved by replacing an SEO agency, $1M+ monthly GMV unlocked through Amazon integration. Every feature I shipped had a clear business metric tied to it.',
  },
  {
    kind: 'body',
    head: 'Data over opinions',
    body: 'I don\'t build on hunches. I instrument everything, track every metric, and let data drive decisions. When I cut support time 80%, the eval harness proved it worked before I ever claimed it.',
  },
  {
    kind: 'body',
    head: 'Automate dependencies away',
    body: 'Paying an agency? I\'ll build the system to replace it. Engineers bottlenecked on support? I\'ll build tools that scale the CS team. If something can be automated, it should be.',
  },
  {
    kind: 'quote',
    q: 'I don\'t see engineering as a cost center. I see it as leverage. Every sprint should have ROI.',
  },
  {
    kind: 'end',
    cta: 'Get in touch →',
    href: 'mailto:pshakilwizard@gmail.com',
  }
    ],
  }
];

export interface LegalDoc {
  slug: string;
  title: string;
  heading: string;
  lede: string;
  description: string;
  updated: string;
  body: string;
}

// /fb-privacy, /fb-data-deletion — Build Box legal pages (Meta developer app).
export const LEGAL_PAGES: LegalDoc[] = [
    {
      slug: 'fb-data-deletion',
      title: 'Data Deletion — Build Box',
      heading: 'Data Deletion',
      lede: 'How to have everything Build Box stored about your Page or account deleted.',
      description: 'Delete your Build Box data: remove the app in Facebook settings and email us — all stored data and tokens are deleted within 30 days.',
      updated: '29 October 2026',
      body: '## How to delete your data from Build Box\n\n1. **Remove the app:** Facebook → Settings & privacy → Settings → Business integrations → select "Build Box" → Remove.\n2. **Email us:** send a message to [shakilwizard@gmail.com](mailto:shakilwizard@gmail.com?subject=Data%20deletion%20request) with the subject "Data deletion request" and the name of the connected Page or account.\n\n## What happens next\n\nWe delete all stored data and access tokens for that account within 30 days and confirm the deletion by email.\n\n## Privacy policy\n\nFor what we collect and why, see the [Privacy Policy](/fb-privacy).',
    },
    {
      slug: 'fb-privacy',
      title: 'Privacy Policy — Build Box',
      heading: 'Privacy Policy',
      lede: 'How Build Box handles data from the Facebook Pages and Instagram accounts you connect.',
      description: 'Build Box privacy policy — what data we access through Meta login, how we use and store it, and how to disconnect or delete it.',
      updated: '29 October 2026',
      body: '## Who we are\n\nBuild Box is a self-hosted social media scheduling tool (Postiz-based) available at [social.buildbox.host](https://social.buildbox.host). It is operated by Anisur Rahman Shakil, Sylhet, Bangladesh. You can contact us at any time at [shakilwizard@gmail.com](mailto:shakilwizard@gmail.com).\n\n## Information we access\n\nWhen you connect a Facebook Page or an Instagram Business/Creator account through Meta\'s login, we receive:\n\n- the Page or account name and ID\n- the profile picture\n- access tokens for the connected Page or account\n- the content you schedule or publish through Build Box\n- comments on those posts\n- Page and account insights\n\n## How we use your data\n\nWe use this data only to:\n\n- schedule and publish the posts you create\n- let you reply to and manage comments on those posts\n- show analytics for the accounts you chose to connect\n\n## Sharing\n\nWe do not sell, rent, or share your data with third parties, and we do not use it for advertising. Data is sent only to Meta\'s APIs to perform the actions you requested in Build Box.\n\n## Storage and security\n\nYour data and access tokens are stored on our own server. Access to them is restricted to the operator.\n\n## Retention\n\nWe keep your data only while the account is connected. It is deleted when you disconnect the account or ask us to delete it.\n\n## Revoking access\n\nYou can revoke Build Box\'s access at any time:\n\n- **Facebook:** Settings & privacy → Settings → Business integrations → remove "Build Box".\n- **Instagram:** Settings → Website permissions / Apps and websites → remove "Build Box".\n\n## Deletion requests\n\nWant everything deleted? The steps are on the [Data Deletion page](/fb-data-deletion).\n\n## Changes to this policy\n\nIf this policy changes, the new version is published on this page with an updated date.',
    },
  ];
